import React, {Fragment, useState} from 'react';
import {Modal, Tooltip, Button, Form, Input} from 'antd';
import {PlusCircleOutlined} from '@ant-design/icons';
import {camelCase} from 'change-case';

// Add-webhook dialog for OpenAPI 3.1 specs. Webhooks are keyed by a plain
// identifier (no URL path), so the form is just a name + optional summary.
// A skeleton PathItem with a single POST operation (200 OK response) is
// created; the user can then refine in the webhook detail view (same per-verb
// tabs UI as interface-view).

function AddWebhookModal({visible, onAddWebhook, setVisible}) {
    const [form] = Form.useForm();

    async function handleOk() {
        try {
            const values = await form.validateFields();
            onAddWebhook(values);
            setVisible(false);
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <Modal
            title="Add New Webhook"
            open={visible}
            closable={true}
            destroyOnHidden
            onCancel={() => setVisible(false)}
            footer={[
                <Button className="addRef" key="cancel" onClick={() => setVisible(false)}>
                    Cancel
                </Button>,
                <Button className="addField" key="create" type="primary" onClick={handleOk}>
                    Create
                </Button>,
            ]}>
            <Form form={form} initialValues={{name: '', summary: ''}} layout="vertical">
                <Form.Item
                    name="name"
                    label="Webhook name"
                    normalize={camelCase}
                    rules={[
                        {required: true, message: 'Name is required (e.g. newPet, orderShipped)'},
                        {pattern: /^[a-zA-Z][a-zA-Z0-9]*$/, message: 'Identifier only: letters and digits, starts with a letter'},
                    ]}
                    extra="Identifier, e.g. newPet, orderShipped, userCreated. Partner systems subscribe to this name.">
                    <Input placeholder="newPet" />
                </Form.Item>
                <Form.Item name="summary" label="Summary (optional)" extra="Short human-readable description of when this webhook fires.">
                    <Input placeholder="Fires when a new pet is registered" />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export function AddWebhookDialog({onAddWebhook, disabled}) {
    const [visible, setVisible] = useState(false);

    return (
        <Fragment>
            <Tooltip title="Add New Webhook">
                <Button
                    disabled={disabled}
                    className="addModel"
                    id="addWebhook"
                    type="link"
                    size="small"
                    onClick={() => setVisible(true)}
                    icon={<PlusCircleOutlined />}
                />
            </Tooltip>
            {visible && <AddWebhookModal visible={visible} setVisible={setVisible} onAddWebhook={onAddWebhook} />}
        </Fragment>
    );
}
